module.exports = __webpack_public_path__ + "img/25.fad31bc9.png";